import styled from 'styled-components';

export const StyledMintModalChoice = styled.div`
  padding-left: 1.5rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 0.375rem;
  width: 100%;
  align-items: center;

  .mint-modal-divider-or {
    text-transform: uppercase;
    font-family: "BebasNeue";
    font-size: 2rem;
    font-weight: 500;
    color: white;
    line-height: 1;
  }

  .mint-modal-divider {
    flex-grow: 1;
    height: ${({ theme }) => theme.frameWidth};
    background: ${({ theme }) => theme.frame};
  }
`;
